'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';
import HomeClientSections from '@/components/home-client-sections';
import { useLanguage } from '@/contexts/language-context';

export default function HomePage() {
  const { t } = useLanguage();

  return (
    <div className="relative min-h-screen">
      {/* Hero Section (original design and branding) */}
      <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-deep-purple dark:text-cream mb-6 text-balance">
              {t('home.heroTitle')}{' '}
              <span className="bg-gradient-to-r from-cloud-blue to-cloud-lavender bg-clip-text text-transparent">
                Agnus Cloud
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-deep-purple/80 dark:text-cream/80 mb-8 max-w-3xl mx-auto text-balance">
              {t('home.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button
                asChild
                size="lg"
                className="bg-gradient-to-r from-cloud-blue to-cloud-lavender hover:from-cloud-blue/90 hover:to-cloud-lavender/90 text-white px-8 py-6 text-lg font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 gradient-button"
              >
                <Link href="https://demo.agnuscloud.com" className="flex items-center gap-2" target="_blank">
                  {t('home.exploreTools')}
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                className="secondary-button px-8 py-6 text-lg font-semibold rounded-full"
              >
                <Link href="/about">{t('home.learnMore')}</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Dynamically loaded client sections (not blocking LCP) */}
      <HomeClientSections />
    </div>
  );
}